import { isValid } from "date-fns";

export const isDateValid = (date: Date | null): boolean | string => {
  return date && !isValid(date) ? "Invalid date" : true;
};
